import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import AliceStore from 'bundles/alice/stores/AliceStore';
import routes from 'bundles/enterprise-learner-search/routes';
import ProgramSwitcherStore from 'bundles/enterprise-legacy-learner-home/stores/ProgramSwitcherStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/global-styles/global-element-styles';

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);
appEnv.registerStore(ProgramSwitcherStore);
appEnv.registerStore(AliceStore);

export default appEnv;
